import { RootState } from "../store";
import { ICartState } from "./types";

export const cartSelector = (state: RootState): ICartState => state.cart;
